import SectionFooter from './SectionFooter';
export default SectionFooter;
